import { ReportingLoaderBaseConfig } from '../../../../base';
import { CollectionItemLoader } from './collectionItemInterface';
import { CollectionItemAggregate } from './collectionItemModel';

export function createCollectionItemLoader(
    config: ReportingLoaderBaseConfig
): CollectionItemLoader {
    const {
        repository: { research },
    } = config;
    return {
        useLoad(context, props): CollectionItemAggregate {
            return {
                collection: props.item.collection,
                document: props.item.document,
            };
        },
    };
}
